import ListingsWrapper from 'vcomponents/listing/ListingsWrapper.vue';
import Listing from 'vcomponents/listing/ListingSwitch.vue';
import OcrList from 'vcomponents/ocr/OcrList.vue';
import OcrListingResolver from 'api/routing/listings/OcrListingResolver';
import PurInvoiceListingResolver from 'api/routing/listings/PurInvoiceListingResolver';
import PurCreditNoteListingResolver from 'api/routing/listings/PurCreditNoteListingResolver';

export default [
    {
        path: '/rest/purInvoice/:id/:type',
        name: 'legacy.purInvoice.save',
    },
    {
        path: '/rest/purCreditNote/:id/:type',
        name: 'legacy.purCreditNote.save',
    },
    {
        path: '/rest/purOrder/:id/:type',
        name: 'legacy.purOrder.save',
    },
    {
        path: '/rest/purDelivery/:id/:type',
        name: 'legacy.purDelivery.save',
    },
    {
        path: '/?_f=purchases_purInvoiceOverview&id={id}',
        name: 'purchase.purInvoice.overview',
    },
    {
        path: '/?_f=purchases_purDeliveryOverview&id={id}',
        name: 'purchase.purDelivery.overview',
    },
    {
        path: '/?_f=purchases_purCreditNoteOverview&id={id}',
        name: 'purchase.purCreditNote.overview',
    },
    {
        path: '/?_f=purchases_purOrderOverview&id={id}',
        name: 'purchase.purOrder.overview',
    },
    {
        path: '/purchase',
        name: 'purchase',
        component: ListingsWrapper,
        props: {
            group: 'purchase',
        },
        children: [
            {
                path: 'incoming',
                name: 'purchase.incoming',
                component: OcrList,
                beforeEnter: (to, from, next) => {
                    new OcrListingResolver().feed(to);
                    next();
                },
                props: true,
            },
            {
                path: 'purInvoice',
                name: 'purchaseinvoices',
                component: Listing,
                beforeEnter: (to, from, next) => {
                    new PurInvoiceListingResolver().feed(to);
                    next();
                },
                props: true,
            },
            {
                path: 'purCreditNote',
                name: 'purchasecreditnotes',
                component: Listing,
                beforeEnter: (to, from, next) => {
                    new PurCreditNoteListingResolver().feed(to);
                    next();
                },
                props: true,
            },
        ],
    },
];
